<template>
	<q-modal
		v-model="show_report"
		:content-css="{ minWidth: '100vw', minHeight: '100vh' }"
		no-backdrop-dismiss
		no-esc-dismiss
	>
		<q-modal-layout>
			<q-toolbar slot="header">
				<q-btn flat round dense @click="show_report = false" icon="fas fa-times" />
				<q-toolbar-title>
					{{ title }}
				</q-toolbar-title>
			</q-toolbar>

			<div class="layout-padding">
				<q-tabs v-model="tab" color="secondary" class="shadow-1">
					<q-tab
						slot="title"
						name="certificate"
						icon="fal fa-file-certificate"
						:label="$t('certificate')"
					/>
					<q-tab
						slot="title"
						name="comments"
						icon="fal fa-star"
						:label="$t('comments')"
					/>
					<q-tab slot="title" name="likes" icon="fal fa-thumbs-up" :label="$t('likes')" />
					<q-tab
						slot="title"
						name="favorites"
						icon="fal fa-heart"
						:label="$t('favorites')"
					/>

					<q-tab-pane name="certificate" class="q-px-lg q-pb-xl" keep-alive>
						<certificates
							:load="tab === 'certificate' && show_report_trails ? true : false"
							:id="id"
							:status="status"
						/>
					</q-tab-pane>

					<q-tab-pane name="comments" class="q-px-lg q-pb-xl" keep-alive>
						<comments
							:load="tab === 'comments' && show_report_trails ? true : false"
							:id="id"
						/>
					</q-tab-pane>

					<q-tab-pane name="likes" class="q-px-lg q-pb-xl" keep-alive>
						<likes
							:load="tab === 'likes' && show_report_trails ? true : false"
							:id="id"
						/>
					</q-tab-pane>

					<q-tab-pane name="favorites" class="q-px-lg q-pb-xl" keep-alive>
						<favorites
							:load="tab === 'favorites' && show_report_trails ? true : false"
							:id="id"
						/>
					</q-tab-pane>
				</q-tabs>
			</div>
		</q-modal-layout>
	</q-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Comments from 'components/admin/trails/report/Comments.vue'
import Likes from 'components/admin/trails/report/Likes.vue'
import Certificates from 'components/admin/trails/report/Certificates.vue'
import Favorites from 'components/admin/trails/report/Favorites.vue'

export default {
	props: ['show_report_trails', 'id', 'status', 'title'],

	components: {
		comments: Comments,
		likes: Likes,
		certificates: Certificates,
		favorites: Favorites,
	},

	data() {
		return {
			tab: 'certificate',
		}
	},

	computed: {
		...mapGetters({
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		title_trails() {
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					return obj.title_trails === '' ? 'trails' : obj.title_trails
				}
			}
		},

		show_report: {
			get() {
				return this.show_report_trails
			},
			set() {
				this.$emit('hide_report_trails', false)
				this.tab = 'certificate'
			},
		},
	},
}
</script>

<style></style>
